import React from "react";

/**
 * v1.25.72 — Tiny dependency-free bar sparkline.
 *
 * Props:
 *   data       number[]  — non-negative values, oldest → newest (left → right)
 *   width      number    — px, default 64
 *   height    number     — px, default 18
 *   colorTop   string    — hex/rgb for tallest bar
 *   colorBase  string    — hex/rgb for zero-height baseline hint
 *   testId     string    — data-testid
 */
export default function Sparkline({
    data = [],
    width = 64,
    height = 18,
    colorTop = "#059669",
    colorBase = "#e2e8f0",
    testId = "sparkline",
}) {
    if (!Array.isArray(data) || data.length === 0) {
        return <span data-testid={`${testId}-empty`} className="inline-block text-[9px] text-slate-300">–</span>;
    }
    const max = Math.max(1, ...data);
    const gap = 1;
    const barW = Math.max(1, (width - (data.length - 1) * gap) / data.length);
    return (
        <svg
            data-testid={testId}
            width={width}
            height={height}
            viewBox={`0 0 ${width} ${height}`}
            preserveAspectRatio="none"
            aria-hidden
            className="align-middle"
        >
            {/* baseline hint */}
            <line x1={0} y1={height - 0.5} x2={width} y2={height - 0.5} stroke={colorBase} strokeWidth={0.5} />
            {data.map((v, i) => {
                const h = v > 0 ? Math.max(1, (v / max) * (height - 1)) : 0;
                const x = i * (barW + gap);
                const y = height - h;
                const fill = v > 0 ? colorTop : colorBase;
                return <rect key={i} x={x} y={y} width={barW} height={h || 0.5} fill={fill} rx={0.5} />;
            })}
        </svg>
    );
}
